import React from 'react';
import './CampusExcellence.css';

const CampusExcellence = () => {
  return (
    <section className="campus-section">
      <div className="container">
        <div className="campus-header">
          <h2 className="section-title">A CAMPUS OF EXCELLENCE</h2>
          <h3 className="section-subtitle">That Prepares for Life</h3>
        </div>
        
        <div className="campus-grid">
          <div className="campus-card indoor">
            <div className="image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/images/indoor.jpeg`}
                alt="Indoor Facilities"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/600x400?text=Indoor+Facilities';
                }}
              />
            </div>
            <div className="card-content">
              <h4>Indoor</h4>
              <p>
                State-of-the-art academic infrastructure to foster an effective 
                and productive educational environment.
              </p>
            </div>
          </div>

          <div className="campus-card outdoor">
            <div className="image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/images/outdoor.jpeg`}
                alt="Outdoor Facilities"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/600x400?text=Outdoor+Facilities';
                }}
              />
            </div>
            <div className="card-content">
              <h4>Outdoor</h4>
              <p>
                Sprawling playgrounds and dedicated co-curricular spaces to 
                nurture sports and other talents.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CampusExcellence;

